let portalParentElementSelector: string | null = 'body';

/**
 * Returns the current portal parent element.
 * @public
 */
export const getPortalParentSelector = (): string => {
  if (portalParentElementSelector) {
    return portalParentElementSelector;
  }
  // If portalParentElement is not set, default to document.body
  portalParentElementSelector = 'body';

  return portalParentElementSelector;
};

/**
 * @private do not export from this package
 */
export const setPortalParentSelector = (selector?: string) => {
  portalParentElementSelector = selector || 'body'; // default to body if no valid parent is provided
};
